import { render, staticRenderFns } from "./SalesTicketsReportView.vue?vue&type=template&id=20a610d7"
import script from "./SalesTicketsReportView.vue?vue&type=script&lang=js"
export * from "./SalesTicketsReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports